import { booleanAttribute, Directive, input } from '@angular/core';

/** Opt-in presentation for the space left behind during a drag. */
@Directive({
    selector: '[qpxDragOrigin]',
    host: {
        '[attr.data-qpx-drag-origin]': 'active() ? "" : null',
    },
})
export class QpxDragOrigin {
    public readonly active = input(false, {
        alias: 'qpxDragOrigin',
        transform: booleanAttribute,
    });
}
